export default "__VITE_ASSET__B4q0KHhK__"